import React from 'react'
import values from 'mout/object/values'
import { StudentAnswerMapPage } from './StudentAnswerMap'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText';

export default function StudentAnswerMapPages({subtests, studentScores, answers, headerText}) {
  const subs = sortByPropText(values(subtests), 'displayName')
  let pages = []
  subs.forEach((subtest) => {
    if (answers[subtest.setId].length <= 40) {
      //
      pages.push({
        subtest, 
        page: 1, 
        answers: answers[subtest.setId]
      })
    } else {
      //make two pages if more than 40!
      pages.push({
        subtest,
        page: 1,
        answers: answers[subtest.setId].slice(0, 40),
      })
      pages.push({
        subtest,
        page: 2,
        answers: answers[subtest.setId].slice(40)
      })
    }
  })
  return (
    pages.map(({subtest, page, answers}) => 
      <StudentAnswerMapPage
        subtest={subtest}
        studentScores={studentScores}
        answers={answers}
        page={page}
        key={`MapPage${subtest.displayName}${page}`}
        headerText={headerText}
      />
    )
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentAnswerMapPages.js